<template lang="pug">
    include ../../media/pug/mixins
    +b.order-card.orders-list__order(
        v-bind:class="{'order-card_active': getOrderId  === order.id,'order-card_fade': faded}"
        v-on:click="handleOrderClick(order.id)"
    )
        +e.BUTTON.remove-btn.btn(
            type="button"
            v-if="type === 'current'"
            v-on:click.stop="$emit('orderDelete', order.id)"
        )
            +e.V-ICON.remove-icon(
                v-bind:name="isMobile ? 'trash' : 'close'"
            )
        +e.inner
            +e.SPAN.title
                | {{ $t('ORDER_NUMBER')+order.id }} #[+e.SPAN.pages {{ order.pages+$t('PAGES') }}]
            +e.SPAN.date {{ order.date }} #[+e.SPAN.time {{ order.time }}]
            +e.status
                template(v-if="type === 'current'")
                    +e.V-ICON.icon_secondary(v-bind:name="'order-not-confirmed'")
                    +e.text {{ $t('NOT_CONFIRMED') }}
                template(v-else)
                    +e.V-ICON.icon_silver(v-bind:name="'order-archived'")
                    +e.text {{ $t('ARCHIVE') }}
            +e.BUTTON.fade-btn.btn(
                v-if="isMobile && type === 'current'"
                v-on:click.stop="fadeOrder"
            )
            +e.BUTTON.btn.btn_theme_fill._size_md(
                v-if="type === 'archive'"
                v-on:click="repaeatOrder(order.id)"
            ) {{ $t('REPEAT_ORDER') }}
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        order: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            faded: false
        };
    },
    computed: {
        ...mapGetters([
            'isMobile',
            'getOrderId'
        ])
    },
    methods: {
        handleOrderClick() {
            if (this.getOrderId !== this.order.id) {
                this.$store.commit('SET_CURRENT_ORDER_ID', this.order.id);
            }
        },
        repaeatOrder() {
            // TODO: repeat order
        },
        fadeOrder() {
            this.faded = !this.faded;
        }
    }
};
</script>

<style lang="sass" src="@/media/sass/components/modules/order-card.sass"></style>
